/* D17 · Cart drawer behaviour (loaded only when Theme settings → Design switches → D17 is on).
   1. Escape closes the drawer wherever focus is (the theme only listened inside it).
   2. Offers from snippets/dz-cart-offers.liquid, one shared path:
      subscribe (D17b) moves a line onto the monthly plan · pack3/pack6 (D17e) adds the pack, then removes the
      line it replaces (add first, so a failed add never loses the customer's bottles) · pair (D17d) adds one item.
      Then the drawer re-renders through the theme's own onCartUpdate, the cart count refreshes, and focus
      returns into the drawer. Each tap is sent to PostHog as cart_offer_add so the offers can be judged.
   3. Partial re-render: on a quantity change the theme rewrote the whole drawer, which rebuilt the express
      buttons (PayPal iframe) and cost a 100+ ms frame at 4x CPU. While the cart stays non-empty, only the lines,
      the totals and the trust line are swapped; the express row stays put. Emptying the cart keeps the full render. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('cart-drawer.active');
    if (d && d.close) d.close();
  });

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' ' + r.status);
      return r.json();
    });
  }

  var PARTS = ['#CartDrawer-CartItems', '.cart-drawer__footer', '.cart__trust-signals'];

  function renderDrawerParts() {
    var url = ((window.routes && routes.cart_url) || root + 'cart') + '?section_id=cart-drawer';
    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var html = new DOMParser().parseFromString(t, 'text/html');
        PARTS.forEach(function (sel) {
          var cur = document.querySelector('cart-drawer ' + sel);
          var next = html.querySelector(sel);
          if (cur && next) cur.innerHTML = next.innerHTML;
        });
      });
  }

  function refresh(focusSelector) {
    var jobs = [renderDrawerParts()];
    document.querySelectorAll('cart-items').forEach(function (el) {
      if (el.onCartUpdate) jobs.push(el.onCartUpdate());
    });
    jobs.push(
      fetch(root + '?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (s) {
          var el = document.getElementById('cart-icon-bubble');
          var html = s && s['cart-icon-bubble'];
          if (!el || !html) return;
          var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (src) el.innerHTML = src.innerHTML;
        })
        .catch(function () {})
    );
    return Promise.all(jobs).then(function () {
      var drawer = document.querySelector('cart-drawer');
      var target = (focusSelector && document.querySelector(focusSelector)) || document.querySelector('#CartDrawer .drawer__heading');
      if (drawer && target && typeof trapFocus === 'function') {
        if (!target.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT)$/.test(target.tagName)) target.setAttribute('tabindex', '-1');
        trapFocus(drawer, target);
      }
    });
  }

  // 3. quantity changes and removals in the drawer: swap parts, keep the express row
  customElements.whenDefined('cart-drawer-items').then(function () {
    var C = customElements.get('cart-drawer-items');
    if (!C || C.prototype.__dzPartial) return;
    var full = C.prototype.getSectionsToRender;
    C.prototype.getSectionsToRender = function () {
      var d = document.querySelector('cart-drawer');
      if (!d || d.classList.contains('is-empty') || !document.querySelector('#CartDrawer .cart__trust-signals')) return full.call(this);
      return [
        { id: 'CartDrawer-CartItems', section: 'cart-drawer', selector: '#CartDrawer-CartItems' },
        { id: 'CartDrawer', section: 'cart-drawer', selector: '.cart-drawer__footer' },
        { id: 'CartDrawer', section: 'cart-drawer', selector: '.cart__trust-signals' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
      ];
    };
    C.prototype.__dzPartial = true;
  });

  function track(kind, b) {
    try {
      if (window.posthog && posthog.capture) {
        posthog.capture('cart_offer_add', { offer: kind, variant_id: b.dataset.add || null, plan: b.dataset.plan || null });
      }
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dz-offer]');
    if (!b || b.disabled) return;
    var kind = b.dataset.dzOffer;
    var plan = b.dataset.plan ? parseInt(b.dataset.plan, 10) : null;
    var job, focus;

    if (kind === 'subscribe') {
      var line = parseInt(b.dataset.line, 10);
      job = post('cart/change.js', { line: line, quantity: parseInt(b.dataset.qty, 10), selling_plan: plan });
      focus = '#CartDrawer-Item-' + line + ' .quantity__input';
    } else if (kind === 'pair' || kind.indexOf('pack') === 0) {
      var item = { id: parseInt(b.dataset.add, 10), quantity: 1 };
      if (plan) item.selling_plan = plan;
      job = post('cart/add.js', { items: [item] });
      if (b.dataset.swapKey) {
        var key = b.dataset.swapKey;
        job = job.then(function () { return post('cart/change.js', { id: key, quantity: 0 }); });
      }
    } else {
      return;
    }

    b.disabled = true;
    b.setAttribute('aria-busy', 'true');
    track(kind, b);
    job
      .then(function () { return refresh(focus); })
      .catch(function () {
        b.disabled = false;
        b.removeAttribute('aria-busy');
        var err = document.getElementById('CartDrawer-CartErrors');
        if (err && window.cartStrings) err.textContent = window.cartStrings.error;
        refresh();
      });
  });
})();
